import React, { Component } from 'react'

export default (props) => {
	// console.log('object :', props)
	// console.log(props.location.state)
	return (
		<React.Fragment>
			{/* {test.find((user) => user.id == props.match.params.id)} */}
		</React.Fragment>
	)
}
